<template>
  <Dialog :visible="true" modal :style="{ width: '48rem' }" :breakpoints="{ '640px': '95vw' }" header="تعديل Hero / الترحيب" @update:visible="$emit('close')">
    <div class="form-field">
      <label class="field-label">نص الشارة</label>
      <input type="text" class="form-control" v-model="form.badge_text" />
    </div>

    <div class="ds-field-grid mt-2">
      <div class="form-field">
        <label class="field-label">الاسم (للزوار)</label>
        <input type="text" class="form-control" v-model="form.name_guest" />
      </div>
      <div class="form-field">
        <label class="field-label">العنوان الفرعي</label>
        <input type="text" class="form-control" v-model="form.subtitle" />
      </div>
    </div>

    <div class="form-field mt-2">
      <label class="field-label">الوصف (للزوار)</label>
      <textarea class="form-control" rows="2" v-model="form.description_guest"></textarea>
    </div>
    <div class="form-field mt-2">
      <label class="field-label">الوصف (للطلاب المسجلين)</label>
      <textarea class="form-control" rows="2" v-model="form.description_auth"></textarea>
    </div>

    <div class="ds-field-grid mt-2">
      <div class="form-field">
        <label class="field-label">زر البحث عن الحجز — النص</label>
        <input type="text" class="form-control" v-model="form.cta_primary.label" />
      </div>
      <div class="form-field">
        <label class="field-label">زر البحث عن الحجز — الرابط</label>
        <input type="text" class="form-control" dir="ltr" v-model="form.cta_primary.link" />
      </div>
    </div>
    <div class="ds-field-grid mt-2">
      <div class="form-field">
        <label class="field-label">زر محتوى الحصص — النص</label>
        <input type="text" class="form-control" v-model="form.cta_auth_primary.label" />
      </div>
      <div class="form-field">
        <label class="field-label">زر محتوى الحصص — الرابط</label>
        <input type="text" class="form-control" dir="ltr" v-model="form.cta_auth_primary.link" />
      </div>
    </div>
    <div class="ds-field-grid mt-2">
      <div class="form-field">
        <label class="field-label">زر الامتحانات — النص</label>
        <input type="text" class="form-control" v-model="form.cta_auth_secondary.label" />
      </div>
      <div class="form-field">
        <label class="field-label">زر الامتحانات — الرابط</label>
        <input type="text" class="form-control" dir="ltr" v-model="form.cta_auth_secondary.link" />
      </div>
    </div>
    <div class="ds-field-grid mt-2">
      <div class="form-field">
        <label class="field-label">نص واتساب</label>
        <input type="text" class="form-control" v-model="form.whatsapp_label" />
      </div>
      <div class="form-field">
        <label class="field-label">رابط واتساب</label>
        <input type="text" class="form-control" dir="ltr" v-model="form.whatsapp_url" />
      </div>
    </div>

    <div class="form-field mt-2">
      <label class="field-label">نص الدليل الاجتماعي <span class="optional">اختياري</span></label>
      <input type="text" class="form-control" v-model="form.social_proof_text" />
    </div>

    <div class="form-field mt-2">
      <label class="field-label">صورة الأستاذ</label>
      <input type="file" class="form-control" accept="image/*" @change="onFile" />
      <img v-if="avatarPreview" :src="avatarPreview" class="hb-preview-thumb hb-preview-thumb--round mt-2" alt="" />
    </div>

    <div class="form-field mt-3">
      <label class="field-label">الإحصائيات الثلاث</label>
      <div v-for="(stat, i) in form.stats" :key="i" class="hb-repeat-row">
        <input type="text" class="form-control hb-col-sm" v-model="stat.icon" placeholder="رمز" />
        <input type="text" class="form-control hb-col-sm" v-model="stat.number" placeholder="الرقم" />
        <input type="text" class="form-control" v-model="stat.label" placeholder="التسمية" />
      </div>
    </div>

    <div class="form-field mt-2 hb-visibility">
      <label class="field-label">الحالة</label>
      <InputSwitch v-model="form.is_active" />
    </div>

    <template #footer>
      <button class="btn-cancel" @click="$emit('close')">إلغاء</button>
      <button class="ds-btn ds-btn--primary" :disabled="store.saving" @click="save">
        <i class="pi pi-check"></i> {{ store.saving ? 'جارٍ الحفظ...' : 'حفظ' }}
      </button>
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import InputSwitch from 'primevue/inputswitch';
import Swal from 'sweetalert2';
import { useHomepageSectionStore } from '@/stores/useHomepageSectionStore.js';
import { appendNested } from './formDataHelpers.js';

function clonePairField(value, fallback) {
  return { label: value?.label ?? fallback.label, link: value?.link ?? fallback.link };
}

export default {
  name: 'HeroEditor',
  components: { Dialog, InputSwitch },
  props: { section: { type: Object, required: true } },
  emits: ['close', 'saved'],
  data() {
    const s = this.section.settings || {};
    return {
      form: {
        badge_text: s.badge_text || '',
        name_guest: s.name_guest || '',
        subtitle: s.subtitle || '',
        description_guest: s.description_guest || '',
        description_auth: s.description_auth || '',
        whatsapp_url: s.whatsapp_url || '',
        whatsapp_label: s.whatsapp_label || '',
        social_proof_text: s.social_proof_text || '',
        cta_primary: clonePairField(s.cta_primary, { label: '', link: '/search' }),
        cta_auth_primary: clonePairField(s.cta_auth_primary, { label: '', link: '/contents' }),
        cta_auth_secondary: clonePairField(s.cta_auth_secondary, { label: '', link: '/exams?type=online' }),
        stats: (s.stats?.length ? s.stats : [{}, {}, {}]).map((st) => ({ icon: st.icon || '', number: st.number || '', label: st.label || '' })),
        is_active: !!this.section.is_active,
      },
      avatarFile: null,
      avatarPreview: s.teacher_avatar || null,
    };
  },
  computed: {
    store() { return useHomepageSectionStore(); },
  },
  methods: {
    onFile(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.avatarFile = file;
      this.avatarPreview = URL.createObjectURL(file);
    },
    async save() {
      try {
        const fd = new FormData();
        const settings = { ...this.form };
        delete settings.is_active;
        appendNested(fd, 'settings', settings);
        fd.append('is_active', this.form.is_active ? 1 : 0);
        if (this.avatarFile) fd.append('avatar_file', this.avatarFile);
        await this.store.updateSection(this.section.id, fd);
        Swal.fire({ icon: 'success', title: 'تم الحفظ', timer: 1400, showConfirmButton: false });
        this.$emit('saved');
      } catch (e) {
        Swal.fire({ icon: 'error', title: e?.response?.data?.message || 'حدث خطأ', timer: 2500, showConfirmButton: false });
      }
    },
  },
};
</script>

<style scoped>
.hb-preview-thumb { max-width: 120px; max-height: 60px; object-fit: contain; border-radius: 8px; border: 1px solid var(--surface-border, #e5e7eb); }
.hb-preview-thumb--round { border-radius: 50%; width: 60px; height: 60px; object-fit: cover; }
.hb-visibility { display: flex; align-items: center; justify-content: space-between; }
.hb-repeat-row { display: flex; gap: 0.5rem; margin-bottom: 0.5rem; }
.hb-col-sm { max-width: 90px; flex-shrink: 0; }
</style>
